import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Tokeny języka projektowego „SYGNAŁ". Importowane RAZ, na wejściu aplikacji — motyw MUI
// (app/theme.ts) czyta z nich przez var(), więc nie ma dwóch źródeł prawdy o kolorze marki.
import './styles/tokens.css';
import './styles/wykresy.css';

const root = document.getElementById('root');
if (!root) throw new Error('Brak elementu #root w dokumencie.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
